import { appRoutes } from './routes';

export const ACCESS_TITLE = 'Доступы';
export const DOCUMENTS_TITLE = 'Документы';
export const USERS_TITLE = 'Пользователи';
export const INTERCEPTIONS_TITLE = 'Перехваты';

export const NAVS = [
  // hide unused pages
  // {
  //   link: appRoutes.MONITORING,
  //   title: 'Лента',
  // },
  // {
  //   link: appRoutes.REPORTS,
  //   title: 'Отчёты',
  // },
  // {
  //   link: appRoutes.DUMPS,
  //   title: 'Утечки',
  // },
  // hide in prod
  // {
  //   link: appRoutes.ENTITIES,
  //   title: 'Таблица',
  // },
  {
    link: appRoutes.MAP,
    title: 'Карта',
  },
  {
    link: appRoutes.DOCUMENTS,
    title: DOCUMENTS_TITLE,
  },
  {
    link: appRoutes.ACCESS,
    title: ACCESS_TITLE,
  },
  {
    link: appRoutes.USERS,
    title: USERS_TITLE,
    adminOnly: true,
  },
  {
    link: appRoutes.INTERCEPTIONS,
    title: INTERCEPTIONS_TITLE,
  },
];
